import React from "react"

import SEO from "../components/seo"
import Header from "../components/Header"
import Arrow from './../images/icons/drop-down.png'
import Poem from './../images/poem.png'
import About from './../images/man-white.jpg'
import Ganbari from './../images/users/ganbari.jpg'
import Mahmoodi from './../images/users/mahmoodi.jpg'
import Farshchi from './../images/users/farshchi.jpg'
import Sakoei from './../images/users/Sakoei.jpg'
import Nayebi from './../images/users/nayebi.jpg'
import Heshmati from './../images/users/heshmati.jpeg'
import Instagram from './../images/icons/instagram.png'
import Telegram from './../images/icons/telegram.png'
import Footer from "../components/Footer"
import ScrollSpy from './../components/ScrollSpy'

export default () => {

  const admins = [
    {
      name: 'حمید قنبری', title: 'مدیر عامل',
      description: `
        با عنایات خداوند متعال و همکاری صمیمانه تیم دیجی مالیات، توانستیم بزرگ ترین سامانه تخصصی قوانین و مقررات مالیاتی کشور را بنا نماییم تا یکی از خلاء هایی که به وضوح در بحث مالیات دیده می‌شد را به بهترین نحو ممکن پر کنیم .
        با تمام وجود فکر و ذکرم در آن است که دیجی مالیات را از نهالی نو، به درختی تنومند برسانم 
        انشاالله
      `,
      img: Ganbari
    },
    // {
    //   name: 'محمد کاظم خدایی', title: 'رییس هیات مدیره',
    //   description: `
    //   مفتخرم که ریاست هیئت مدیره دیجی مالیات را به بنده محول کرده‌اند در این مدت ۲۰ سال انجام خدمات مالی و مالیاتی با مدرک دکترای تخصصی در رشته حسابداری همیشه فکر بر آن داشتم که چگونه می توانم به همکاران و مودیان مالیاتی در انجام امور و وظایف قانونی مالیاتی کمک کنم تا این که با همیاری دوستان عزیزمان بهتر دیدیم که از طریق این سیستم عظیم مالیاتی این ماموریت خطیر را انجام دهیم
    //   `,
    //   img: Khodai
    // },
    {
      name: 'سینا محمودی', title: 'مدیر تکنولوژی',
      description: `
        افتخار پیاده سازی سیستم دیجی مالیات با به روزترین تکنولوژی ها و مدیریت تیم نرم افزاری را داشتم. همیشه هدفم یادگیریست 
        و همواره به دنبال ایجاد ابزاری هستم که بتوانم نقش خود را در خدمت رسانی به جامعه ام ایفا کرده باشم.
      `,
      img: Mahmoodi
    },
    {
      name: 'بهراد فرشچی', title: 'مدیر سمعی و بصری',
      description: `
      خدای عزوجل را شاکرم که در این پروژه عظیم حضور یافته،
      عزمم را جزم کرده تا سامانه ای را طراحی کنم که لایق چشم های نظاره گر هموطنان عزیزمان باشد و همیشه سعی بر آن دارم که با بهترین و جدیدترین متد های طراحی روز دنیا سامانه را بهبود بخشیده تا کاربران گرامی موقع استفاده، لبخند رضایت بر لبانشان نمایان شود.
      `,
      img: Farshchi
    },
    {
      name: 'آسیه سکوئی', title: 'عضو کارگروه اطلاع رسانی مالیاتی',
      description: `بهترین راه رسیدن به رضایت واقعی این است که آنچه به بزرگ بودن آن اعتقاد دارید را انجام دهید . باور من همراهی با
      تیم بزرگی است که فعل توانستن را صرف کرده ودر مسیر ایجاد فرهنگ مدرن مالیاتی در جامعه مالی ومالیاتی کشور قرار
      گرفته است . از خداوند بزرگ خواهان آنم ، که دراین راه مفید واقع شوم.`,
      img: Sakoei
    },
    // {
    //   name: 'نسترن مرندی', title: 'برنامه نویس',
    //   description: `تلاش دیجی مالیات و انجمن های همکار برای ارائه خدمات بهتر می‌تواند در ارتقا فرهنگ مالیاتی مودیان و عدم فرار مالیاتی موثر باشد
    //   تلاش دیجی مالیات و انجمن های همکار برای ارائه خدمات بهتر می‌تواند در ارتقا فرهنگ مالیاتی مودیان و عدم فرار مالیاتی موثر باشد
    //   تلاش دیجی مالیات و انجمن های همکار برای ارائه خدمات بهتر می‌تواند`,
    //   img: Marandi
    // },
    // {
    //   name: 'شقایق نایبی', title: 'برنامه نویس',
    //   description: `دانشجوی کارشناسی مهندسی کامپیوتر در دانشگاه تبریز`,
    //   img: Nayebi
    // },
    // {
    //   name: 'نازنین اذانی', title: 'کارشناس مالیاتی',
    //   description: `کارشناس مالی دیجی مالیات
    //   فارغ التحصیل رشته اقتصاد نظری از دانشگاه علامه طباطبایی
    //   مفتخرم به عضویت در خانواده دیجی مالیات و همکاری با اساتید و همکاران خوبم از ابتدای فعالیت دیجی مالیات تاکنون،  با همکاران عزیزم در راستای آموزش و پاسخ به سوالات شما عزیزان در خدمتتان هستیم.`,
    //   img: Azani
    // },
    // {
    //   name: 'مینا حشمتی', title: 'کارشناس مالیاتی',
    //   description: `
    //   فارغ التحصیل رشته های حسابداری و مدیریت بازرگانی
    //   خوشحالم که از شروع کار دیجی مالیات در کنار اساتید و همکاران محترمم هستم
    //   و در راستای اطلاع رسانی مالیاتی و پاسخگویی به سوالات شما کاربران گرامی در خدمتتون هستم
    //   و سعی بر آن دارم که بتوانم در کنار همکارانم بهترین آموزش های مالیاتی را برای شما کاربران عزیز آماده کنم`,
    //   img: Heshmati
    // }
  ]

  return (
    <div className="slideInTop">
      <SEO title="درباره ما" />
      <Header />
      <ScrollSpy />
      <div id="parrent" className="overflow-auto rtl">
        <div className="mx-auto" style={{ height: 'calc(100vh - var(--top-nav-height))' }}>
          <div className="px-64"
            style={{ height: 'calc(100vh - var(--top-nav-height))', backgroundAttachment: 'fixed', maxHeight: 700, backgroundImage: `url(${About})`, backgroundPosition: '0 -64px', backgroundSize: 'cover' }}>
            <div className="absolute" style={{
              bottom: 0,
              right: 'calc(50% - 22px)'
            }}>
              <button className="bd-none bg-none icon-button notifyMe" style={{ filter: 'drop-shadow(0px -4px 0px #464953)' }}
                onClick={() => document.getElementById('content-holder').scrollIntoView({ behavior: 'smooth' })}>
                <span className="bg-bg icon-mask thumb blocked" style={{
                  WebkitMaskImage: `url(${Arrow})`,
                  WebkitMaskSize: 'contain'
                }} />
              </button>
            </div>
          </div>
          <div id="content-holder" className="container pt-64">
            <section className="px-64 pb-45">
              <div>
                <img src={Poem} alt="" className="mx-auto blocked" />
              </div>

              <div className="pt-16 pb-45">
                <div className="px-64">
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    دیجی مالیات یعنی برنامه ریزی جامع ذهنی نوین برای ایجاد فرهنگ مدرن مالیاتی در جامعه مالی و مالیاتی کشور با بهره گیری از تکنولوژی های هوشمند آموزشی و بهره گیری از نرم افزارهای حرفه ای  با پدید آوردن هوش مصنوعی در جهت خدمت به عام مردم .
                  </p>
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    حیات و ممات هر جامعه ای به اقتصاد آن بستگی دارد و زمانی که حیات اقتصادی آن پویا باشد، آن جامعه در همه ابعاد شاخص های رفاه اجتماعی موفق خواهد شد.
                    هر اقتصادی ابزار کنترلی دقیقی را نیاز دارد که بتواند میزان پیشرفت آن را صحیح اندازه گیری نماید و آن ابزار همان مالیات است که افراد جامعه با مشارکت در آن، در مسیر پیشرفت جامعه گام برمیدارند و مشارکت جامعه جز با فرهنگ سازی اجتماعی میسر نخواهد شد .
                  </p>
                  <p className="font-16 bold text-center" style={{ lineHeight: 2.2 }}>
                    هدف <span className="text-tomato">دیجی مالیات</span>، داشتن جامعه ای با فرهنگ مدرن مالیاتی با بالاترین سطح رفاه اجتماعی است.
                  </p>
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    سامانه نرم افزاری واطلاع رسانی دیجی مالیات سعی برآن دارد تا با کمک جامعه مشاوران مالیاتی و سایر انجمن های مالی ، حسابرسی ، مدیریتی فعالیت‌های مالیاتی خود را به صورت آموزش دیجیتالی و مبتنی بر استفاده از فناوری‌های الکترونیکی پایه‌ریزی نماید.
                  </p>
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    این نوع آموزش تحت عنوان آموزش اینترنتی، آموزش تحت وب و آموزش نوین نیز نامیده می‌شود. در این شکل جدید از آموزش زیر‌ساخت‌های دیجیتالی، بسترهای لازم برای همکاری، ارتباط، جست‌وجوی اطلاعات و فعالیت‌های افراد و سازمان‌امور مالیاتی را فراهم می‌کند.
                  </p>
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    تلاش دیجی مالیات و انجمن های همکار برای ارائه خدمات بهتر می‌تواند در ارتقا فرهنگ مالیاتی مودیان و عدم فرار مالیاتی موثر باشد با استفاده از ابزار فناوری اطلاعات ، مودیان مالیاتی می توانند فعالیتهای آموزشی مالیاتی خود را در هر ساعت از شبانه روز و از هر نقطه ای انجام دهند.
                  </p>
                  <p className="font-16" style={{ lineHeight: 2.2 }}>
                    دیجی مالیات توسط متخصصین دکتری حسابداری و نرم افزارهای رایانه ای تهیه گردیده و کلیه منابع محتوایی قوانین و مقررات آن از مجلس شورای اسلامی و سایت سازمان امور مالیاتی کشور تهیه و تامین شده است.
                  </p>
                </div>
              </div>
            </section>
            {false && <section className="px-64 pb-45">
              <div className="pb-45 text-center">
                <span className="font-14">تیم ما</span>
                <h3 className="text-shadow font-24" style={{ marginRight: -20 }}>
                  <img className="icon-sm ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                  ما اینجاییم تا فعل توانستن را صرف کنیم
                </h3>
              </div>
              {/* admins */}
              <div className="grid px-64" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gridGap: 45 }}>
                {
                  admins.map((admin, index) => (
                    <div key={index} className="about-item radius-8 overflow-hidden">
                      <div className="img overflow-hidden"
                        style={{ height: 256, backgroundImage: `url(${admin.img})`, backgroundPosition: 'center', backgroundSize: '100%' }} />
                      <div className="overlay px-32 pt-24 pb-12 h-100 flexed fdir-col justify-between">
                        <div>
                          <h3 className="text-top-nav mt-0 mb-4">{admin.name}</h3>
                          <span className="text-top-nav">{admin.title}</span>
                        </div>
                        <p className="text-top-nav font-10">{admin.description}</p>
                        <div className="ltr">
                          <a href="/" className="mr-16 inline-blocked">
                            <span className="bg-top-nav icon-mask blocked" style={{
                              WebkitMaskImage: `url(${Telegram})`,
                              WebkitMaskSize: 'contain',
                              width: 26,
                              height: 28
                            }}>
                            </span>
                          </a>
                          <a href="/" className="mr-16 inline-blocked">
                            <span className="bg-top-nav icon-mask blocked" style={{
                              WebkitMaskImage: `url(${Instagram})`,
                              WebkitMaskSize: 'contain',
                              width: 26,
                              height: 28
                            }}>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>

            </section>}
          </div>
          <Footer />
        </div>
      </div>
    </div >
  )
}
